import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import { usePools } from '../DatabaseContext';
import ChoiceQuestion from '../Fields/ChoiceQuestion';
import FormContainer from '../Fields/FormContainer';
import NumberQuestion from '../Fields/NumberQuestion';
import SaveAndContinue from '../Fields/SaveAndContinue';

export default function DimensionsPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const [surfaceArea, setSurfaceArea] = useState(10)
    const [depth, setDepth] = useState(0)
    const [type, setType] = useState(0)

    const updateFields = () => {
        setSurfaceArea(pool?.surface_area)
        setDepth(pool?.depth)
        setType(pool?.construction_type)
    }

    const notReady = () => {
        return !(
            id &&
            pool &&
            surfaceArea !== undefined &&
            depth !== undefined &&
            type !== undefined
        );
    }

    useEffect(() => {
        setPoolId(id);
        updateFields();
    }, [id])

    useEffect(() => {
        updateFields();
    }, [pool])

    if (notReady()) {
        return <BubbleLoader />
    }

    return <FormContainer needsValidPool={ false } breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading },
    ]} >

        <p>{ i18n.dimensions.heading }</p>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
            <div>
                <NumberQuestion
                    value={ surfaceArea }
                    onChange={ setSurfaceArea }
                    name="surface_area"
                    label={i18n.dimensions.surfaceArea}
                    small={true}
                    hint={i18n.dimensions.surfaceAreaHint}
                />
            </div>
            <div>
                <NumberQuestion
                    value={ depth }
                    onChange={ setDepth }
                    name="depth"
                    label={i18n.dimensions.depth}
                    small={true}
                    hint={i18n.dimensions.depthHint}
                />
            </div>
        </div>

        <div className="mt-8">
            <ChoiceQuestion
                label={ i18n.dimensions.type }
                name="construction_type"
                onChange={ setType }
                value={ type }
                options={[
                    { label: i18n.dimensions.skimmer, value: 'In-ground skimmer' },
                    { label: i18n.dimensions.overflow, value: 'In-ground overflow' },
                    { label: i18n.dimensions.other, value: 'Other' },
                ]}
            />
        </div>

        <SaveAndContinue id={ pool?.id } data={{
            depth,
            surface_area: surfaceArea,
            construction_type: type,
        }} next="temperature" />

    </FormContainer>
}
